<template>
  <div class="operations-table">
    <div class="operations-table-lg">
      <scrolled-table :fix-first="true" :fix-last="edit">
        <operations-table
          :columns="columns"
          :dates="dates"
          :sort-by="sortBy"
          :edit="edit"
          :can-remove="canRemove"
          @sort="sort"
          @remove="remove"
          @restore="restore"
        />
      </scrolled-table>
    </div>

    <operations-table-sm
      class="operations-table-sm"
      :columns="columns"
      :dates="dates"
      :sort-by="sortBy"
      :edit="edit"
      :can-remove="canRemove"
      @sort="sort"
      @remove="remove"
      @restore="restore"
    />

    <div v-if="dates.length === 0" class="operations-table-empty">Записи не найдены</div>
  </div>
</template>
<script>
import OperationsTable from "./table";
import OperationsTableSm from "./table-sm";
import ScrolledTable from "@/components/scrolled-table";

import { groupOperationsByDate, DateOperations } from "./date-operations";

const columns = [
  {
    id: "operationDate",
    sort: "date_created",
    title: "Дата операции",
    className: "account-history__date",
  },
  {
    id: "transactionDate",
    sort: "date_user",
    title: "Дата проводки",
    className: "account-history__date",
  },
  {
    id: "balanceStart",
    sort: "balance",
    title: "Остаток лс на начало дня, ฿",
    className: "account-history__balance-start",
    status: "active",
  },
  {
    id: "salary",
    sort: "sum_salary",
    title: "Начислено осн. часть, ฿",
    titleSm: "Нач-но осн.часть, ฿",
    className: "account-history__main",
    status: "active",
  },
  {
    id: "dynamic",
    sort: "sum_dynamic",
    title: "Начислено перем. часть, ฿",
    titleSm: "Нач-но перем. часть, ฿",
    className: "account-history__dynamic",
    status: "active",
  },
  {
    id: "bonus",
    sort: "sum_bonus",
    title: "Премия, ฿",
    className: "account-history__bonus",
    status: "active",
  },
  {
    id: "penalty",
    sort: "sum_penalty",
    title: "Штраф, ฿",
    className: "account-history__fine",
    status: "active",
  },
  {
    id: "amount",
    sort: "amount",
    title: "Внесено/снято, ฿",
    className: "account-history__amount",
  },
  {
    id: "balanceEnd",
    sort: "balance_end",
    title: "Остаток лс на конец дня, ฿",
    className: "account-history__balance-end",
    status: "active",
  },
  {
    id: "author",
    sort: "author",
    title: "Кто внес/снял",
    className: "account-history__author",
  },
  {
    id: "reason",
    sort: "comment",
    title: "Причина/комментарий",
    titleSm: "Причина/коммент-й",
    className: "account-history__reason",
  },
  {
    id: "filial",
    sort: "filial",
    title: "Филиал",
    titleSm: "Филиал",
    className: "account-history__reason",
  },  
  {
    id: "removalAuthor",
    sort: "delete_author",
    title: "Кто удалил",
    className: "account-history__removal-author",
    status: "removed",
  },
  {
    id: "removalDate",
    sort: "delete_date",
    title: "Дата удаления",
    className: "account-history__removal-date",
    status: "removed",
  },
  {
    id: "removalComment",
    sort: "delete_comment",
    title: "Комментарий к удалению",
    className: "account-history__removal-comment",
    status: "removed",
  },
  {
    id: "actions",
    className: "account-history__calculation",
    canEdit: true,
    status: "active",
  },
  {
    id: "restore",
    className: "account-history__calculation",
    status: "removed",
  },
];

export default {
  name: "account-history-table",
  components: {
    "operations-table": OperationsTable,
    OperationsTableSm,
    ScrolledTable,
  },
  props: ["operations", "sortBy", "desc", "status", "edit", "canRemove"],
  data() {
    return {
      dates: [],
    };
  },
  computed: {
    columns() {
      return columns.filter((column) => {
        // console.log({ column, status: this.status, canEdit: this.edit });
        if (column.status && column.status !== this.status) return false;
        if (column.canEdit && !this.edit) return false;

        return true;
      });
    },
  },
  watch: {
    operations(v) {
      if (this.sortBy === "date_created") {
        this.dates = groupOperationsByDate(v);
      } else {
        this.dates = v.map((v) => new DateOperations(v.date, [v]));
      }
    },
  },

  created() {
    if (this.sortBy === "date_created") {
      this.dates = groupOperationsByDate(this.operations);
    } else {
      this.dates = this.operations.map((v) => new DateOperations(v.date, [v]));
    }
  },

  methods: {
    sort(column) {
      this.$emit("sort", column);
    },
    remove(transaction) {
      this.$emit("remove", transaction);
    },
    restore(transaction) {
      this.$emit("restore", transaction);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.operations-table {
  position: relative;

  .operations-table-sm {
    display: none;
  }
  .operations-table-empty {
    border: 1px solid #dfe4ef;
    background: white;
    color: #8e9cbb;
    font-size: 13px;
    position: relative;
    z-index: 2;
    margin-top: -14px;
    text-align: center;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @include onlyMobile {
    .operations-table-lg {
      display: none;
    }
    .operations-table-sm {
      display: block;
      margin-left: -21px;
      margin-right: -21px;
    }
    .operations-table-empty {
      position: absolute;
      top: 0;
      left: -20px;
      right: -20px;
      bottom: 0;
      margin-top: 0;
      height: auto;
    }
  }
}
</style>
